
import about from '../../api/about'
export default { 


    data(){
        return { 
            about : null
        }
    },

    created(){
        about.getCompanyProfile({}).then(res=>{
            this.about = res;
        })
    }

}